import $ from 'jquery';
import primaryNav from './header/nav-primary';
import languageChooser from './interface/language-chooser';

function bodyClasses() {
    const $body = $('body');

    $(document).on('balloon:unscrolled', function () {
        $body.addClass('unscrolled').removeClass('scrolled');
    });
    $(document).on('balloon:scrolled', function () {
        $body.addClass('scrolled').removeClass('unscrolled');
    });

    $(document).on('balloon:viewport', function (event, device) {
        $body.removeClass('device-mobile device-tablet device-tablet-and-up device-desktop device-ultra device-custom portrait portrait-and-up landscape landscape-and-up');
        document.device = device;
        $body.addClass(' device-' + device);

        if (device === 'tablet landscape' || device === 'desktop') {
            $body.addClass('device-tablet-and-up portrait-and-up landscape-and-up');
        }
        if (device === 'tablet portrait') {
            $body.addClass('device-tablet-and-up portrait-and-up');
        }
    });
}

function init() {
    bodyClasses();
    primaryNav.init();
    languageChooser.init();
}

export default {init: init};
